import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { concatAll, concatMap, debounceTime, map, Observable, of, Subject, Subscription, switchMap } from 'rxjs';
import {
	ALL_SERVICE_TYPES,
	categoryInterface,
	impactInterface,
	requestClassificationInterface,
	scopeInterface,
	SERVICE_TYPES,
	serviceTypeInterface,
	severityInterface,
	solutionAreaInterface,
	urgencyInterface,
} from 'src/app/util/interfaces/requestClassification';
import { RequestClassificationService } from '../request-classification/service/request-classification.service';
import { RequestClassificationReverseService } from './service/request-classification-reverse.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { classificationInterface } from 'src/app/util/interfaces/classification';
import {
	iacOptionInterface,
	InputWithAutocompleteComponent,
} from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
import { CommonModule } from '@angular/common';
import { DotBounceLoadingEffectModule } from 'src/app/page_component_item/dot-bounce-loading-effect/dot-bounce-loading-effect.module';
import { InputWithAutocompleteModule } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.module';

@Component({
	standalone: true,
	imports: [CommonModule, DotBounceLoadingEffectModule, InputWithAutocompleteModule],
	selector: 'pcp-request-classification-reverse-rmk',
	templateUrl: './request-classification-reverse-rmk.component.html',
	styleUrl: './request-classification-reverse-rmk.component.scss',
})
export class RequestClassificationReverseRmkComponent implements OnInit, OnChanges {
	labels: LabelsInterface = {
		lbl_geral_grupo: '',
		lbl_chamado_tipo_servico: '',
		lbl_geral_competencia: '',
		lbl_geral_natureza: '',
		lbl_geral_topico: '',
		lbl_geral_severidade: '',
		lbl_geral_selecione: '',
		lbl_geral_impacto: '',
		lbl_geral_urgencia: '',
	};

	constructor(
		private RequestClassificationReverseService: RequestClassificationReverseService,
		private ProfileService: ProfileService,
		private LabelsService: LabelsService
	) {}

	_isLoadingLabels = true;
	_isCascating = false;

	@Input() lockField: (
		| 'solutionArea'
		| 'serviceType'
		| 'scope'
		| 'category'
		| 'topic'
		| 'impact'
		| 'urgency'
		| 'severity'
		| 'changeType'
	)[] = [];
	@Input() hideField: (
		| 'solutionArea'
		| 'serviceType'
		| 'scope'
		| 'category'
		| 'topic'
		| 'impact'
		| 'urgency'
		| 'severity'
		| 'changeType'
	)[] = [];
	@Input() hideServiceType: SERVICE_TYPES[] = [];
	@Input() alertField: (
		| 'solutionArea'
		| 'serviceType'
		| 'scope'
		| 'category'
		| 'topic'
		| 'impact'
		| 'urgency'
		| 'severity'
		| 'changeType'
	)[] = [];
	@Input() onMe = false; //Esse parâmetro faz retornar o grupo inicial apenas grupos que estão vinculados ao meu analista
	@Input() allCustomer = false;
	@Input() definedUrgency = false; //Retorna apenas classificações que tem urgência definida
	@Input() idTargetCi = null; //Retorna apenas classificações que podem vincular com este ci.

	@Input() idCustomerList: string;
	@Input() setClassificationId: {
		idSolutionArea: string;
		idServiceType: string;
		idScope: string;
		idCategory: string;
		idTopic: string;
		idImpact: string;
		idUrgency: string;
		idSeverity: string;
	} = {
		idSolutionArea: undefined,
		idServiceType: undefined,
		idScope: undefined,
		idCategory: undefined,
		idTopic: undefined,
		idImpact: undefined,
		idUrgency: undefined,
		idSeverity: undefined,
	};

	_idSolutionArea = undefined;
	_idServiceType = undefined;
	_idScope = undefined;
	_idCategory = undefined;
	_idTopic = undefined;
	_idImpact = undefined;
	_idUrgency = undefined;
	_idSeverity = undefined;

	_availableClassification: requestClassificationInterface = {
		solutionArea: [],
		serviceType: [],
		scope: [],
		category: [],
		topic: [],
		impact: [],
		urgency: [],
		severity: [],
	};
	_selectedClassification: requestClassificationInterface = {
		solutionArea: [],
		serviceType: [],
		scope: [],
		category: [],
		topic: [],
		impact: [],
		urgency: [],
		severity: [],
	};

	classificationSubscription: Subscription;

	_idCustomerList: string;

	urgencyClassification = '';
	impactClassification = '';

	@Output() getClassification = new EventEmitter();
	@Output() wasClassificationEditedAfterLoad = new EventEmitter();
	@Output() isClassificationFulfilled = new EventEmitter();
	@Output() isLoadingClassification = new EventEmitter();

	ngOnInit(): void {
		this._idCustomerList = this.idCustomerList == undefined ? this.ProfileService.userData().idCustomer : this.idCustomerList;

		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this._isLoadingLabels = false;
		});

		this.cascateClassification();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.setClassificationId) {
			this._idSolutionArea = this.setClassificationId.idSolutionArea;
			this._idServiceType = this.setClassificationId.idServiceType;
			this._idScope = this.setClassificationId.idScope;
			this._idCategory = this.setClassificationId.idCategory;
			this._idTopic = this.setClassificationId.idTopic;
			this._idImpact = this.setClassificationId.idImpact;
			this._idUrgency = this.setClassificationId.idUrgency;
			this._idSeverity = this.setClassificationId.idSeverity;
			this.resetAvailableClassificationUntil('solutionArea');
			this.cascateClassification();

			if (!changes.setClassificationId.isFirstChange()) {
				this.wasClassificationEditedAfterLoad.emit(true);
			}
		}
	}

	getAvailableSolutionAreasReq(): Observable<solutionAreaInterface[]> {
		if (this._availableClassification.solutionAreaIAC != undefined && this._availableClassification.solutionAreaIAC.length > 0)
			return of(this._availableClassification.solutionArea);
		const serviceTypes = ALL_SERVICE_TYPES.filter((serviceType) => !this.hideServiceType?.includes(serviceType));
		return this.RequestClassificationReverseService.getSolutionAreas(
			this._idCustomerList,
			this.onMe,
			this.allCustomer,
			this.definedUrgency,
			serviceTypes,
			this.idTargetCi
		);
	}

	getAvailableServiceTypesReq(idSolutionArea: string): Observable<serviceTypeInterface[]> {
		if (this._availableClassification.serviceTypeIAC != undefined && this._availableClassification.serviceTypeIAC.length > 0)
			return of(this._availableClassification.serviceType);
		const serviceTypes = ALL_SERVICE_TYPES.filter((serviceType) => !this.hideServiceType?.includes(serviceType));
		return this.RequestClassificationReverseService.getClassification(
			this._idCustomerList,
			'serviceType',
			idSolutionArea,
			idSolutionArea,
			this.definedUrgency,
			'',
			serviceTypes,
			this.idTargetCi
		);
	}

	getAvailableScopesReq(idServiceType: string, idSolutionArea: string): Observable<scopeInterface[]> {
		if (this._availableClassification.scopeIAC != undefined && this._availableClassification.scopeIAC.length > 0)
			return of(this._availableClassification.scope);
		return this.RequestClassificationReverseService.getClassification(
			this._idCustomerList,
			'scope',
			idServiceType,
			idSolutionArea,
			this.definedUrgency,
			idServiceType,
			this.idTargetCi
		);
	}

	getAvailableCategoriesReq(idScope: string, idSolutionArea: string, idServiceType: string): Observable<categoryInterface[]> {
		if (this._availableClassification.categoryIAC != undefined && this._availableClassification.categoryIAC.length > 0)
			return of(this._availableClassification.category);
		return this.RequestClassificationReverseService.getClassification(
			this._idCustomerList,
			'category',
			idScope,
			idSolutionArea,
			this.definedUrgency,
			idServiceType,
			this.idTargetCi
		);
	}

	getAvailableTopicsReq(idCategory: string, idSolutionArea: string, idServiceType: string): Observable<categoryInterface[]> {
		if (this._availableClassification.topicIAC != undefined && this._availableClassification.topicIAC.length > 0)
			return of(this._availableClassification.topic);
		return this.RequestClassificationReverseService.getClassification(
			this._idCustomerList,
			'topic',
			idCategory,
			idSolutionArea,
			this.definedUrgency,
			idServiceType,
			this.idTargetCi
		);
	}

	getAvailableImpactReq(idSolutionArea: string): Observable<impactInterface[]> {
		if (this._availableClassification.impactIAC != undefined && this._availableClassification.impactIAC.length > 0)
			return of(this._availableClassification.impact);
		return this.RequestClassificationReverseService.getImpact(true, idSolutionArea);
	}

	getAvailableUrgencyReq(idTopic: string, idSolutionArea: string): Observable<urgencyInterface[]> {
		if (this._availableClassification.urgencyIAC != undefined && this._availableClassification.urgencyIAC.length > 0)
			return of(this._availableClassification.urgency);
		return this.RequestClassificationReverseService.getUrgency(true, idTopic, idSolutionArea);
	}

	getAvailableSeverityReq(idImpact: string, idUrgency: string): Observable<severityInterface[]> {
		if (this._availableClassification.severityIAC != undefined && this._availableClassification.severityIAC.length > 0)
			return of(this._availableClassification.severity);
		return this.RequestClassificationReverseService.getSeverity(idImpact, idUrgency, true, this._idCustomerList);
	}

	resetAvailableClassificationUntil(step: string): void {
		switch (step) {
			case 'solutionArea': {
				this._availableClassification.serviceType = [];
				this._availableClassification.serviceTypeIAC = [];
			}
			case 'serviceType': {
				this._availableClassification.scope = [];
				this._availableClassification.scopeIAC = [];
			}
			case 'scope': {
				this._availableClassification.category = [];
				this._availableClassification.categoryIAC = [];
			}
			case 'category': {
				this._availableClassification.topic = [];
				this._availableClassification.topicIAC = [];
			}
			case 'topic': {
				this._availableClassification.impact = [];
				this._availableClassification.urgency = [];
				this._availableClassification.impactIAC = [];
				this._availableClassification.urgencyIAC = [];
			}
			case 'impact':
			case 'urgency': {
				this._availableClassification.severity = [];
				this._availableClassification.severityIAC = [];
			}
			case 'severity':
			default:
		}
	}

	resetSelectedClassificationUntil(step: string): void {
		switch (step) {
			case 'solutionArea': {
				this._idServiceType = undefined;
			}
			case 'serviceType': {
				this._idScope = undefined;
			}
			case 'scope': {
				this._idCategory = undefined;
			}
			case 'category': {
				this._idTopic = undefined;
			}
			case 'topic': {
				this._idImpact = undefined;
				this._idUrgency = undefined;
			}
			case 'impact':
			case 'urgency': {
				this._idSeverity = undefined;
			}
			case 'severity':
			default:
		}
	}

	changeValue(changedField: string, changedValue: string): void {
		const evaluateIdChangedField = `_id${changedField.charAt(0).toUpperCase() + changedField.slice(1)}`;
		if (!changedValue || changedValue == '') this.resetSelectedClassificationUntil(changedField);
		(this as any)[evaluateIdChangedField] = changedValue;
		this.resetAvailableClassificationUntil(changedField);
		this.cascateClassification();
	}

	setDynamicValue(variableName: string, value: string): void {
		(this as any)[variableName] = value;
	}

	cascateClassification(classificationElement?: InputWithAutocompleteComponent): void {
		this._isCascating = true;
		this.isLoadingClassification.emit(true);
		if (this.classificationSubscription) this.classificationSubscription.unsubscribe();

		//GET SOLUTION AREA
		this.classificationSubscription = this.getAvailableSolutionAreasReq()
			.pipe(
				///GET SERVICE TYPE?
				concatMap((availableSolutionAreasRes) => {
					if (availableSolutionAreasRes && this._idSolutionArea) {
						const sa = availableSolutionAreasRes.find((sa) => {
							return sa.id.toString() == this._idSolutionArea.toString();
						});
						if (sa == undefined) {
							this.resetSelectedClassificationUntil('solutionArea');
							return of({ availableSolutionAreasRes, availableServiceTypesRes: [] });
						} else {
							return this.getAvailableServiceTypesReq(this._idSolutionArea).pipe(
								map((availableServiceTypesRes) => ({ availableSolutionAreasRes, availableServiceTypesRes }))
							);
						}
					} else {
						return of({ availableSolutionAreasRes, availableServiceTypesRes: [] });
					}
				}),
				//GET SCOPE?
				concatMap(({ availableSolutionAreasRes, availableServiceTypesRes }) => {
					if (availableSolutionAreasRes && availableServiceTypesRes && this._idServiceType) {
						const st = availableServiceTypesRes.find((st) => {
							return st.id.toString() == this._idServiceType.toString();
						});
						if (st == undefined) {
							this.resetSelectedClassificationUntil('serviceType');
							return of({ availableSolutionAreasRes, availableServiceTypesRes, availableScopeRes: [] });
						} else {
							return this.getAvailableScopesReq(this._idServiceType, this._idSolutionArea).pipe(
								map((availableScopeRes) => ({ availableSolutionAreasRes, availableServiceTypesRes, availableScopeRes }))
							);
						}
					} else {
						return of({ availableSolutionAreasRes, availableServiceTypesRes, availableScopeRes: [] });
					}
				}),
				//GET CATEGORY?
				concatMap(({ availableSolutionAreasRes, availableServiceTypesRes, availableScopeRes }) => {
					if (availableSolutionAreasRes && availableServiceTypesRes && availableScopeRes && this._idScope) {
						const sc = availableScopeRes.find((sc) => {
							return sc.id.toString() == this._idScope.toString();
						});
						if (sc == undefined) {
							this.resetSelectedClassificationUntil('scope');
							return of({
								availableSolutionAreasRes,
								availableServiceTypesRes,
								availableScopeRes,
								availableCategoriesRes: [],
							});
						} else {
							return this.getAvailableCategoriesReq(this._idScope, this._idSolutionArea, this._idServiceType).pipe(
								map((availableCategoriesRes) => ({
									availableSolutionAreasRes,
									availableServiceTypesRes,
									availableScopeRes,
									availableCategoriesRes,
								}))
							);
						}
					} else {
						return of({ availableSolutionAreasRes, availableServiceTypesRes, availableScopeRes, availableCategoriesRes: [] });
					}
				}),
				//GET TOPIC?
				concatMap(({ availableSolutionAreasRes, availableServiceTypesRes, availableScopeRes, availableCategoriesRes }) => {
					if (
						availableSolutionAreasRes &&
						availableServiceTypesRes &&
						availableScopeRes &&
						availableCategoriesRes &&
						this._idCategory
					) {
						const cat = availableCategoriesRes.find((cat) => {
							return cat.id.toString() == this._idCategory.toString();
						});
						if (cat == undefined) {
							this.resetSelectedClassificationUntil('category');
							return of({
								availableSolutionAreasRes,
								availableServiceTypesRes,
								availableScopeRes,
								availableCategoriesRes,
								availableTopicsRes: [],
							});
						} else {
							return this.getAvailableTopicsReq(this._idCategory, this._idSolutionArea, this._idServiceType).pipe(
								map((availableTopicsRes) => ({
									availableSolutionAreasRes,
									availableServiceTypesRes,
									availableScopeRes,
									availableCategoriesRes,
									availableTopicsRes,
								}))
							);
						}
					} else {
						return of({
							availableSolutionAreasRes,
							availableServiceTypesRes,
							availableScopeRes,
							availableCategoriesRes,
							availableTopicsRes: [],
						});
					}
				}),
				//GET IMPACT?
				concatMap(
					({
						availableSolutionAreasRes,
						availableServiceTypesRes,
						availableScopeRes,
						availableCategoriesRes,
						availableTopicsRes,
					}) => {
						if (
							availableSolutionAreasRes &&
							availableServiceTypesRes &&
							availableScopeRes &&
							availableCategoriesRes &&
							availableTopicsRes &&
							(this._idServiceType?.toString() == '1' || this._idServiceType?.toString() == '2') &&
							this._idTopic
						) {
							const top = availableTopicsRes.find((top) => {
								return top.id.toString() == this._idTopic.toString();
							});
							if (top == undefined) {
								this.resetSelectedClassificationUntil('impact');
								return of({
									availableSolutionAreasRes,
									availableServiceTypesRes,
									availableScopeRes,
									availableCategoriesRes,
									availableTopicsRes,
									availableImpactRes: [],
								});
							} else {
								return this.getAvailableImpactReq(this._idSolutionArea).pipe(
									map((availableImpactRes) => ({
										availableSolutionAreasRes,
										availableServiceTypesRes,
										availableScopeRes,
										availableCategoriesRes,
										availableTopicsRes,
										availableImpactRes,
									}))
								);
							}
						} else {
							return of({
								availableSolutionAreasRes,
								availableServiceTypesRes,
								availableScopeRes,
								availableCategoriesRes,
								availableTopicsRes,
								availableImpactRes: [],
							});
						}
					}
				),
				//GET URGENCY?
				concatMap(
					({
						availableSolutionAreasRes,
						availableServiceTypesRes,
						availableScopeRes,
						availableCategoriesRes,
						availableTopicsRes,
						availableImpactRes,
					}) => {
						if (
							availableSolutionAreasRes &&
							availableServiceTypesRes &&
							availableScopeRes &&
							availableCategoriesRes &&
							availableTopicsRes &&
							(this._idServiceType?.toString() == '1' || this._idServiceType?.toString() == '2') &&
							this._idTopic
						) {
							const top = availableTopicsRes.find((top) => {
								return top.id.toString() == this._idTopic.toString();
							});
							if (top == undefined) {
								this.resetSelectedClassificationUntil('urgency');
								return of({
									availableSolutionAreasRes,
									availableServiceTypesRes,
									availableScopeRes,
									availableCategoriesRes,
									availableTopicsRes,
									availableImpactRes,
									availableUrgencyRes: [],
								});
							} else {
								return this.getAvailableUrgencyReq(this._idTopic, this._idSolutionArea).pipe(
									map((availableUrgencyRes) => ({
										availableSolutionAreasRes,
										availableServiceTypesRes,
										availableScopeRes,
										availableCategoriesRes,
										availableTopicsRes,
										availableImpactRes,
										availableUrgencyRes,
									}))
								);
							}
						} else {
							return of({
								availableSolutionAreasRes,
								availableServiceTypesRes,
								availableScopeRes,
								availableCategoriesRes,
								availableTopicsRes,
								availableImpactRes,
								availableUrgencyRes: [],
							});
						}
					}
				),
				//GET SEVERITY?
				concatMap(
					({
						availableSolutionAreasRes,
						availableServiceTypesRes,
						availableScopeRes,
						availableCategoriesRes,
						availableTopicsRes,
						availableImpactRes,
						availableUrgencyRes,
					}) => {
						if (availableImpactRes?.length > 0) {
							const defaultImpact = availableImpactRes.find((item) => item.default_classification);
							if (defaultImpact && this.impactClassification === '') {
								this.impactClassification = defaultImpact.id;
								this._idImpact = defaultImpact.id;
								this._selectedClassification.impact[0] = {
									label: defaultImpact.label,
									name: defaultImpact.name,
									id: defaultImpact.id,
									impact: defaultImpact.id,
									default: defaultImpact.default,
								};
							}
						}
						if (availableUrgencyRes?.length > 0) {
							const defaultUrgency = availableUrgencyRes.find((item) => item.default_classification);
							if (defaultUrgency && this.urgencyClassification === '') {
								this.urgencyClassification = defaultUrgency.id;
								this._idUrgency = defaultUrgency.id;
								this._selectedClassification.urgency[0] = {
									label: defaultUrgency.label,
									name: defaultUrgency.name,
									id: defaultUrgency.id,
									urgency: defaultUrgency.id,
									default: defaultUrgency.default,
								};
							}
						}
						if (
							availableSolutionAreasRes &&
							availableServiceTypesRes &&
							availableScopeRes &&
							availableCategoriesRes &&
							availableTopicsRes &&
							(this._idServiceType?.toString() == '1' || this._idServiceType?.toString() == '2') &&
							this._idImpact &&
							this._idUrgency
						) {
							const imp = availableImpactRes.find((imp) => {
								return imp.id.toString() == this._idImpact.toString();
							});
							const urg = availableUrgencyRes.find((urg) => {
								return urg.id.toString() == this._idUrgency.toString();
							});

							if (imp != undefined && urg != undefined) {
								return this.getAvailableSeverityReq(this._idImpact, this._idUrgency).pipe(
									map((availableSeverityRes) => ({
										availableSolutionAreasRes,
										availableServiceTypesRes,
										availableScopeRes,
										availableCategoriesRes,
										availableTopicsRes,
										availableImpactRes,
										availableUrgencyRes,
										availableSeverityRes,
									}))
								);
							} else {
								this.resetSelectedClassificationUntil('severity');
								return of({
									availableSolutionAreasRes,
									availableServiceTypesRes,
									availableScopeRes,
									availableCategoriesRes,
									availableTopicsRes,
									availableImpactRes,
									availableUrgencyRes,
									availableSeverityRes: [],
								});
							}
						} else {
							return of({
								availableSolutionAreasRes,
								availableServiceTypesRes,
								availableScopeRes,
								availableCategoriesRes,
								availableTopicsRes,
								availableImpactRes,
								availableUrgencyRes,
								availableSeverityRes: [],
							});
						}
					}
				)
			)
			.subscribe(
				({
					availableSolutionAreasRes,
					availableServiceTypesRes,
					availableScopeRes,
					availableCategoriesRes,
					availableTopicsRes,
					availableImpactRes,
					availableUrgencyRes,
					availableSeverityRes,
				}) => {
					this._availableClassification.solutionArea = availableSolutionAreasRes;
					this._availableClassification.serviceType = availableServiceTypesRes;
					this._availableClassification.scope = availableScopeRes;
					this._availableClassification.category = availableCategoriesRes;
					this._availableClassification.topic = availableTopicsRes;
					this._availableClassification.impact = availableImpactRes;
					this._availableClassification.urgency = availableUrgencyRes;
					this._availableClassification.severity = availableSeverityRes;

					this._availableClassification.solutionAreaIAC = [];
					this._availableClassification.serviceTypeIAC = [];
					this._availableClassification.scopeIAC = [];
					this._availableClassification.categoryIAC = [];
					this._availableClassification.topicIAC = [];
					this._availableClassification.impactIAC = [];
					this._availableClassification.urgencyIAC = [];
					this._availableClassification.severityIAC = [];

					for (const sa of this._availableClassification.solutionArea) {
						const iacOption: iacOptionInterface = { name: sa.label, value: sa.id };
						this._availableClassification.solutionAreaIAC.push(iacOption);
						if (sa.id.toString() == this._idSolutionArea?.toString()) {
							this._selectedClassification.solutionArea[0] = { label: sa.label, name: sa.name, id: sa.id };
						}
					}

					for (const st of this._availableClassification.serviceType) {
						const iacOption: iacOptionInterface = { name: st.label, value: st.id };
						this._availableClassification.serviceTypeIAC.push(iacOption);
						if (st.id.toString() == this._idServiceType?.toString()) {
							this._selectedClassification.serviceType[0] = { label: st.label, name: st.name, id: st.id };
						}
					}

					for (const sc of this._availableClassification.scope) {
						const iacOption: iacOptionInterface = { name: sc.name, value: sc.id };
						this._availableClassification.scopeIAC.push(iacOption);
						if (sc.id.toString() == this._idScope?.toString()) {
							this._selectedClassification.scope[0] = {
								label: sc.label,
								name: sc.name,
								id: sc.id,
								allowedCiTypes: sc.allowedCiTypes,
							};
						}
					}

					for (const cat of this._availableClassification.category) {
						const iacOption: iacOptionInterface = { name: cat.label, value: cat.id };
						this._availableClassification.categoryIAC.push(iacOption);
						if (cat.id.toString() == this._idCategory?.toString()) {
							this._selectedClassification.category[0] = { label: cat.label, name: cat.name, id: cat.id };
						}
					}

					for (const top of this._availableClassification.topic) {
						const iacOption: iacOptionInterface = { name: top.label, value: top.id };
						this._availableClassification.topicIAC.push(iacOption);
						if (top.id.toString() == this._idTopic?.toString()) {
							this._selectedClassification.topic[0] = { label: top.label, name: top.name, id: top.id };
						}
					}

					for (const imp of this._availableClassification.impact) {
						const iacOption: iacOptionInterface = { name: imp.label, value: imp.id };
						this._availableClassification.impactIAC.push(iacOption);
						if (imp.id.toString() == this._idImpact?.toString()) {
							this._selectedClassification.impact[0] = {
								label: imp.label,
								name: imp.name,
								id: imp.id,
								impact: imp.id,
								default: imp.default,
							};
						}
					}

					for (const urg of this._availableClassification.urgency) {
						const iacOption: iacOptionInterface = { name: urg.label, value: urg.id };
						this._availableClassification.urgencyIAC.push(iacOption);
						if (urg.id.toString() == this._idUrgency?.toString()) {
							this._selectedClassification.urgency[0] = {
								label: urg.label,
								name: urg.name,
								id: urg.id,
								urgency: urg.id,
								default: urg.default,
							};
						}
					}

					if (this._availableClassification.severity.length > 0) {
						const sev = this._availableClassification.severity[0];
						this._availableClassification.severityIAC.push({ name: sev.label, value: sev.severity });
						this._idSeverity = sev.severity;
						this._selectedClassification.severity[0] = { label: sev.label, name: sev.name, id: sev.id, severity: sev.severity };
					}

					this._isCascating = false;
					this.isLoadingClassification.emit(false);
					this.getClassification.emit(JSON.stringify(this._selectedClassification));

					setTimeout(() => {
						if (classificationElement == undefined) return;
						classificationElement.focusMainInput();
						classificationElement.openOptions = false;
					}, 100);

					setTimeout(() => {
						if (
							(this._idTopic != undefined &&
								this._idServiceType.toString() != '1' &&
								this._idServiceType.toString() != '2') ||
							(this._idTopic != undefined && this._idSeverity != undefined)
						) {
							this.isClassificationFulfilled.emit(true);
						} else {
							this.isClassificationFulfilled.emit(false);
						}
					}, 1000);
				}
			);
	}
}
